export const emitter = Symbol("emitter");
